// Leest de superadmin-sessie uit de custom claims van het ID-token.
//
// De claims worden server-side gezet door de startSuperAdminSession Cloud
// Function. Ze zijn niet vanuit de browser te schrijven — dit bestand LEEST
// ze alleen, voor de banner en de knoppen. De echte grens ligt in de
// Firestore-rules, die dezelfde twee velden toetsen.
//
// AI-CONTEXT: See docs/features/superadmin-tenant-access.md

const SU_TENANT_CLAIM = 'suT'
const SU_EXPIRY_CLAIM = 'suE'

const readSuperAdminSession = (claims, nowMs) => {

    const compagnyId = claims?.[SU_TENANT_CLAIM]
    const expiresAt = claims?.[SU_EXPIRY_CLAIM]

    if (typeof compagnyId !== 'string' || compagnyId === '') return null
    if (typeof expiresAt !== 'number' || !Number.isFinite(expiresAt)) return null

    const msLeft = expiresAt - nowMs

    return {
        compagnyId,
        expiresAt,
        msLeft: msLeft > 0 ? msLeft : 0,
        // Een verlopen sessie blijft zichtbaar in het token (tot een uur lang),
        // maar de rules wijzen 'm af. `active` volgt de rules, niet het token.
        active: msLeft > 0,
    }
}

const formatTimeLeft = (msLeft) => {
    if (typeof msLeft !== 'number' || !Number.isFinite(msLeft) || msLeft <= 0) return 'verlopen'

    const totalMinutes = Math.ceil(msLeft / 60000)
    if (totalMinutes < 60) return `${totalMinutes} min`

    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60
    return minutes === 0 ? `${hours} uur` : `${hours} uur ${minutes} min`
}

export { SU_TENANT_CLAIM, SU_EXPIRY_CLAIM, formatTimeLeft }
export default readSuperAdminSession
